<div class="improving-access container-fluid py-5 position-relative">
    <div class="container-xxxl py-0 py-lg-2 my-0 my-lg-4">
        <div class="row align-items-lg-center fs-md-18 d-print-block">
            <div class="col-12 col-lg intro-panel mb-5 mb-lg-0">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-maroon border-maroon">{{ articleUnderstandIntro.title }}</h2>
                    </div>
                </div>
                <div [innerHTML]="articleUnderstandIntro.bodyText"></div>
            </div>
            <div class="col-12 col-lg offset-xl-1">
                <div class="row row-cols-1 row-cols-md-2 gx-4 gy-5">
                    <div class="col pe-xl-5">
                        <div class="d-flex flex-column align-items-center align-items-md-start mb-2">
                            <img class="h3-icon mb-3 d-print-none" [src]="imgPath + articleTabAAboutDisease.images[0].url + '-200.webp'" alt="" />
                            <h3 class="mb-3 fs-22 fw-bold text-maroon text-center text-md-start" [innerHTML]="articleTabAAboutDisease.title"></h3>
                            <div class="text-center text-md-start" [innerHTML]="articleTabAAboutDisease.bodyText"></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="d-flex flex-column align-items-center align-items-md-start mb-2">
                            <img class="h3-icon mb-3 d-print-none" [src]="imgPath + articleTabBDiagnosisTreatment.images[0].url + '-200.webp'" alt="" />
                            <h3 class="mb-3 fs-22 fw-bold text-maroon text-center text-md-start" [innerHTML]="articleTabBDiagnosisTreatment.title"></h3>
                            <div class="text-center text-md-start" [innerHTML]="articleTabBDiagnosisTreatment.bodyText"></div>
                        </div>
                    </div>
                    <div class="col pe-xl-5">
                        <div class="d-flex flex-column align-items-center align-items-md-start mb-2">
                            <img class="h3-icon mb-3 d-print-none" [src]="imgPath + articleTabCLivingDisease.images[0].url + '-200.webp'" alt="" />
                            <h3 class="mb-3 fs-22 fw-bold text-maroon text-center text-md-start" [innerHTML]="articleTabCLivingDisease.title"></h3>
                            <div class="text-center text-md-start" [innerHTML]="articleTabCLivingDisease.bodyText"></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="d-flex flex-column align-items-center align-items-md-start mb-2">
                            <img class="h3-icon mb-3 d-print-none" [src]="imgPath + articleTabDResearch.images[0].url + '-200.webp'" alt="" />
                            <h3 class="mb-3 fs-22 fw-bold text-maroon text-center text-md-start" [innerHTML]="articleTabDResearch.title"></h3>
                            <div class="text-center text-md-start" [innerHTML]="articleTabDResearch.bodyText"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-circle-background d-print-none">
        <div class="circle-top-left"></div>
        <div class="circle-outline-top-left"></div>
        <div class="circle-outline-huge-left"></div>
        <div class="circle-outline-small-center"></div>
        <div class="circle-bottom-right-center"></div>
        <div class="circle-big-right"></div>
        <div class="circle-outline-right"></div>
    </div>
</div>
